import { LoadingOutlined } from '@ant-design/icons';
import { notification, Space, Spin } from 'antd';
import styled from 'styled-components';

const StyledSpace = styled(Space)`
	.spin {
		margin-right: 1em;
	}
`;

interface Props {
	message: string;
	description: string;
	clientCode: string;
}

export const createLoadingNotification = (props: Props): void => {
	const { message: title, description, clientCode } = props;

	notification.open({
		message: title,
		description: (
			<StyledSpace>
				<div className="spin">
					<Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
				</div>
				{description}
			</StyledSpace>
		),
		key: clientCode,
		duration: 0,
		closeIcon: false,
		role: 'status',
		style: { width: 'max-content' },
	});
};
